import React from 'react';

const QuickStartSidebar = ({ steps, activeStep, onStepChange }) => {
    const getDifficultyColor = (difficulty) => {
        switch (difficulty) {
            case 'Facile': return 'from-green-500 to-emerald-500';
            case 'Moyen': return 'from-amber-500 to-yellow-500';
            case 'Intermédiaire': return 'from-orange-500 to-amber-500';
            case 'Avancé': return 'from-red-500 to-orange-500';
            default: return 'from-gray-500 to-gray-600';
        }
    };

    return (
        <nav className="sticky top-24 bg-white rounded-2xl shadow-lg border border-amber-100/50 p-6">
            <div className="mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Guide de Démarrage</h3>
                <p className="text-sm text-gray-600">Suivez les étapes dans l'ordre</p>
            </div>

            <ul className="space-y-2">
                {steps.map((step, index) => {
                    const isCompleted = steps.findIndex(s => s.id === activeStep) > index;
                    const isActive = activeStep === step.id;

                    return (
                        <li key={step.id}>
                            <button
                                onClick={() => onStepChange(step.id)}
                                className={`w-full text-left p-4 rounded-xl transition-all duration-300 group ${
                                    isActive
                                        ? 'bg-gradient-to-r from-amber-100 to-yellow-100 border-2 border-amber-200 shadow-md'
                                        : 'border border-transparent hover:border-amber-200 hover:bg-amber-50/50'
                                } ${isCompleted ? 'opacity-100' : ''}`}
                            >
                                <div className="flex items-center space-x-3">
                                    <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center text-lg ${
                                        isActive
                                            ? 'bg-gradient-to-r from-amber-500 to-yellow-500 text-white'
                                            : isCompleted
                                                ? 'bg-green-100 text-green-600'
                                                : 'bg-amber-100 text-amber-600'
                                    }`}>
                                        {isCompleted ? '✓' : step.icon}
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center justify-between mb-1">
                                            <span className={`font-semibold text-sm ${
                                                isActive ? 'text-amber-700' : 'text-gray-700'
                                            }`}>
                                                {step.title}
                                            </span>
                                            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
                                                {step.duration}
                                            </span>
                                        </div>
                                        <div className="flex items-center justify-between">
                                            <span className={`text-xs px-2 py-1 rounded-full ${
                                                isActive
                                                    ? 'bg-amber-500 text-white'
                                                    : `bg-gradient-to-r ${getDifficultyColor(step.difficulty)} text-white`
                                            }`}>
                                                {step.difficulty}
                                            </span>
                                            <span className="text-xs text-gray-500">
                                                {index + 1}/{steps.length}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </li>
                    );
                })}
            </ul>

            {/* Progress Bar */}
            <div className="mt-8 pt-6 border-t border-gray-200">
                <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-700">Progression</span>
                    <span className="text-sm text-amber-600 font-semibold">
                        {Math.round((steps.findIndex(step => step.id === activeStep) + 1) / steps.length * 100)}%
                    </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                        className="bg-gradient-to-r from-amber-500 to-yellow-500 h-2 rounded-full transition-all duration-500"
                        style={{ width: `${(steps.findIndex(step => step.id === activeStep) + 1) / steps.length * 100}%` }}
                    ></div>
                </div>
            </div>

            {/* Quick Tips */}
            <div className="mt-6 p-4 bg-amber-50 rounded-lg border border-amber-200">
                <h4 className="font-semibold text-amber-800 text-sm mb-2">💡 Astuce Rapide</h4>
                <p className="text-amber-700 text-xs">
                    Utilisez l'environnement de test pour vos premiers essais.
                </p>
            </div>
        </nav>
    );
};

export default QuickStartSidebar;